import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";

import EditButton from "components/CustomButtons/EditButton";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getSite,
  postActionImpact,
} from "services/ConfigServices";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const [totalRows, setTotalRows] = useState(0);
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    getSavings();
  }, [isRefetched, action.parameters?.impact?.targetedenergy]);

  const getSavings = () => {
    setStructureData(action.parameters?.impact?.targetedenergy || []);
  };

  const SubHeaderComponent = () => {
    return (
      <>
        <TableName>Simulation</TableName>
      </>
    );
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: <SubHeaderComponent />,
    },
    refreshTable,
  };
}
